import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input, Output, EventEmitter, } from "@angular/core";
import { AppState } from "../../../app.service";
import * as comp from "./contact-details-inputfields";
import { TrackingError } from "@api/services/tracking";
var MIN_AGE = 18;
var MAX_AGE = 119;
var ContactDetailsComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function ContactDetailsComponent(appState) {
        this.appState = appState;
        this.scrollToErrorMsg = new EventEmitter();
        /**
         * Form values
         */
        // Dropdowns
        this.birthDay = "Tag";
        this.birthMonth = "Monat";
        this.birthYear = "Jahr";
        this.citizenship = "";
        // Dropdowns Errors
        this.birthDateError = false; // numeric?
        this.citizenshipError = false; // string
        // Inputs and Radios
        this.companyNameObj = comp.companyNameObj;
        this.companyRegistrationObj = comp.companyRegistrationObj;
        this.companyLegalLocationObj = comp.companyLegalLocationObj;
        this.titleObj = comp.titleObj;
        this.firstNameObj = comp.firstNameObj;
        this.lastNameObj = comp.lastNameObj;
        this.companyRegistrationEntryObj = comp.companyRegistrationEntryObj;
        this.registrationNumberObj = comp.registrationNumberObj;
        this.contactDetailInput = comp.ContactDetailInput;
        this.streetObj = comp.streetObj;
        this.streetNumberObj = comp.streetNumberObj;
        this.zipCodeObj = comp.zipCodeObj;
        this.cityObj = comp.cityObj;
        this.phonePrefixObj = comp.phonePrefixObj;
        this.phoneNumberObj = comp.phoneNumberObj;
        this.emailObj = comp.emailObj;
        this.passwordObj = comp.passwordObj;
        this.fixednetCustomerNumberObj = comp.fixednetCustomerNumberObj;
        this.divergentBillingAddressObj = comp.divergentBillingAddressObj;
        this.divergentBillingAddressNameObj = comp.divergentBillingAddressNameObj;
        this.divergentBillingAddressStreetObj = comp.divergentBillingAddressStreetObj;
        this.divergentBillingAddressStreetNumberObj = comp.divergentBillingAddressStreetNumberObj;
        this.divergentBillingAddressZipCodeObj = comp.divergentBillingAddressZipCodeObj;
        this.divergentBillingAddressCityObj = comp.divergentBillingAddressCityObj;
        this.registeredInputs = [
            this.companyNameObj,
            this.titleObj,
            this.firstNameObj,
            this.lastNameObj,
            this.companyRegistrationEntryObj,
            this.registrationNumberObj,
            this.companyLegalLocationObj,
            this.streetObj,
            this.streetNumberObj,
            this.zipCodeObj,
            this.cityObj,
            this.phonePrefixObj,
            this.phoneNumberObj,
            this.emailObj,
            this.passwordObj,
        ];
        this.notRegisteredInputs = [
            this.titleObj,
            this.firstNameObj,
            this.lastNameObj,
            this.streetObj,
            this.streetNumberObj,
            this.zipCodeObj,
            this.cityObj,
            this.phonePrefixObj,
            this.phoneNumberObj,
            this.emailObj,
            this.passwordObj,
        ];
        this.divergentBillingAddressInputs = [
            this.divergentBillingAddressNameObj,
            this.divergentBillingAddressStreetObj,
            this.divergentBillingAddressStreetNumberObj,
            this.divergentBillingAddressZipCodeObj,
            this.divergentBillingAddressCityObj,
        ];
        // + dropdowns
        /**
         * Set our default values
         */
        this.localState = { value: "" };
        this.patterns = {
            NUMERIC: /^\d+$/,
            STRING: /^[a-zA-ZàáâäãåacceèéêëeiìíîïlnòóôöõøùúûüuuÿýzzñçcszÀÁÂÄÃÅACCEEÈÉÊËÌÍÎÏILNÒÓÔÖÕØÙÚÛÜUUYÝZZÑßÇOÆCSZð &!?,‚.:'\-\(\)\/]+$/,
            EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            ALPHANUMERIC: /^\d+[a-zA-Z]*$/,
            STRING_NUMERIC: /^[0-9a-zA-ZàáâäãåacceèéêëeiìíîïlnòóôöõøùúûüuuÿýzzñçcszÀÁÂÄÃÅACCEEÈÉÊËÌÍÎÏILNÒÓÔÖÕØÙÚÛÜUUYÝZZÑßÇOÆCSZ?ð &!?,.:'\-\(\)\/]+$/,
            STRING_NUMERIC_ONLY: /^([0-9a-zA-Z]{6,10})$/,
        };
        /**
         * helpers
         */
        this.years = [];
        this.days = [];
    }
    ContactDetailsComponent.prototype.ngOnInit = function () {
        // setting initial values for radio buttons
        this.companyRegistrationObj.inputValue = this.companyRegistrationObj
            .getOptions()[0]
            .getValue();
        this.companyRegistrationEntryObj.inputValue =
            this.companyRegistrationEntryObj.getOptions()[0].getValue();
        this.titleObj.inputValue = this.titleObj.getPlaceholder();
        this.years = [];
        this.divergentBillingAddressObj.inputValue =
            this.divergentBillingAddressObj.getOptions()[0].getValue();
        var date = new Date();
        date.setFullYear(date.getFullYear() - MIN_AGE);
        for (var i = date.getFullYear(); i > date.getFullYear() - (MAX_AGE - MIN_AGE); i--) {
            this.years.push(i.toString());
        }
        this.onChangeDate();
    };
    ContactDetailsComponent.prototype.basicValidation = function (formInputObj) {
        var value = formInputObj.inputValue;
        var minLength = formInputObj.getMinLength();
        var maxLength = formInputObj.getMaxLength();
        var valType = formInputObj.getValType();
        var invalid = this.validateInput({
            valType: valType,
            value: value,
            minLength: minLength,
            maxLength: maxLength,
        });
        var tracking = new TrackingError();
        if (invalid) {
            formInputObj.hasError = true;
            tracking
                .setType("validation")
                .setMessage(formInputObj.getTrackingErrorMsg())
                .setLocation("checkout")
                .track();
        }
        else {
            formInputObj.hasError = false;
        }
    };
    ContactDetailsComponent.prototype.validateForm = function () {
        var _this = this;
        var companyType = this.companyRegistrationObj.inputValue;
        var divergentBillingAddress = this.divergentBillingAddressObj.inputValue;
        var formHasError = true;
        var divergentBillingAddressHasError = true;
        if (companyType === "registered") {
            this.registeredInputs.forEach(function (inputObj) {
                _this.basicValidation(inputObj);
            });
            formHasError =
                this.registeredInputs.findIndex(function (inputObj) {
                    return inputObj.hasError || inputObj.inputValue === "";
                }) != -1;
        }
        else if (companyType === "not_registered") {
            this.notRegisteredInputs.forEach(function (inputObj) {
                _this.basicValidation(inputObj);
            });
            this.birthDateError = this.birthdayHasError();
            this.citizenshipError = this.citizenshipHasError();
            if (divergentBillingAddress === "yes") {
                this.divergentBillingAddressInputs.forEach(function (inputObj) {
                    _this.basicValidation(inputObj);
                });
                divergentBillingAddressHasError =
                    this.divergentBillingAddressInputs.findIndex(function (inputObj) {
                        return inputObj.hasError || inputObj.inputValue === "";
                    }) != -1;
            }
            else {
                divergentBillingAddressHasError = false;
            }
            formHasError =
                this.notRegisteredInputs.findIndex(function (inputObj) {
                    return inputObj.hasError || inputObj.inputValue === "";
                }) != -1 ||
                    divergentBillingAddressHasError ||
                    this.birthDateError ||
                    this.citizenshipError;
        }
        else
            return;
        return !formHasError;
    };
    ContactDetailsComponent.prototype.validateInput = function (_a) {
        var valType = _a.valType, value = _a.value, minLength = _a.minLength, maxLength = _a.maxLength;
        var invalid = false;
        switch (valType) {
            case comp.ValType.STRING_NUMERIC: {
                invalid = this.testStringNumeric({
                    value: value,
                    minLength: minLength,
                    maxLength: maxLength,
                });
                break;
            }
            case comp.ValType.STRING: {
                invalid = this.testString({ value: value, minLength: minLength, maxLength: maxLength });
                break;
            }
            case comp.ValType.ALPHA_NUMERIC: {
                invalid = this.testAlphaNumeric({
                    value: value,
                    minLength: minLength,
                    maxLength: maxLength,
                });
                break;
            }
            case comp.ValType.NUMERIC: {
                invalid = this.testNumeric({ value: value, minLength: minLength, maxLength: maxLength });
                break;
            }
            case comp.ValType.EMAIL: {
                invalid = this.testEmail({ value: value, minLength: minLength, maxLength: maxLength });
                break;
            }
            case comp.ValType.STRING_NUMERIC_ONLY: {
                invalid = this.testStringNumericOnly({
                    value: value,
                    minLength: minLength,
                    maxLength: maxLength,
                });
                break;
            }
        }
        return invalid;
    };
    ContactDetailsComponent.prototype.testStringNumeric = function (_a) {
        var value = _a.value, minLength = _a.minLength, maxLength = _a.maxLength;
        return (!this.patterns.STRING_NUMERIC.test(value) ||
            value.length < minLength ||
            value.length > maxLength);
    };
    ContactDetailsComponent.prototype.testNumeric = function (_a) {
        var value = _a.value, minLength = _a.minLength, maxLength = _a.maxLength;
        return (!this.patterns.NUMERIC.test(value) ||
            value.length < minLength ||
            value.length > maxLength);
    };
    ContactDetailsComponent.prototype.testString = function (_a) {
        var value = _a.value, minLength = _a.minLength, maxLength = _a.maxLength;
        return (!this.patterns.STRING.test(value) ||
            value.length < minLength ||
            value.length > maxLength);
    };
    ContactDetailsComponent.prototype.testAlphaNumeric = function (_a) {
        var value = _a.value, minLength = _a.minLength, maxLength = _a.maxLength;
        return (!this.patterns.ALPHANUMERIC.test(value) ||
            value.length < minLength ||
            value.length > maxLength);
    };
    ContactDetailsComponent.prototype.testEmail = function (_a) {
        var value = _a.value, minLength = _a.minLength, maxLength = _a.maxLength;
        return (!this.patterns.EMAIL.test(value) ||
            value.length < minLength ||
            value.length > maxLength);
    };
    ContactDetailsComponent.prototype.testStringNumericOnly = function (_a) {
        var value = _a.value, minLength = _a.minLength, maxLength = _a.maxLength;
        return (!this.patterns.STRING_NUMERIC_ONLY.test(value) ||
            value.length < minLength ||
            value.length > maxLength);
    };
    ContactDetailsComponent.prototype.birthdayHasError = function () {
        var tracking = new TrackingError();
        var hasError = false;
        if (!this.patterns.NUMERIC.test(this.birthDay) ||
            !this.patterns.NUMERIC.test(this.birthMonth) ||
            !this.patterns.NUMERIC.test(this.birthYear)) {
            tracking
                .setType("validation")
                .setMessage("Contact Details: Invalid birth date")
                .setLocation("checkout")
                .track();
            hasError = true;
            this.birthDateError = true;
        }
        return hasError;
    };
    ContactDetailsComponent.prototype.citizenshipHasError = function () {
        var tracking = new TrackingError();
        var hasError = false;
        if (!this.patterns.STRING.test(this.citizenship) ||
            this.citizenship.length < 1 ||
            this.citizenship.length > 50) {
            tracking
                .setType("validation")
                .setMessage("Contact Details: Invalid citizenship")
                .setLocation("checkout")
                .track();
            hasError = true;
            this.citizenshipError = true;
        }
        return hasError;
    };
    ContactDetailsComponent.prototype.submitForm = function () {
        var tracking = new TrackingError();
        if (!this.validateForm()) {
            this.scrollToErrorMsg.emit();
            return;
        }
        else {
            this.submitContactDetails();
        }
    };
    ContactDetailsComponent.prototype.submitContactDetails = function () {
        var contactDetails = {
            birthDay: this.companyRegistrationObj.inputValue === "not_registered"
                ? this.birthDay
                : "01",
            birthMonth: this.companyRegistrationObj.inputValue === "not_registered"
                ? this.birthMonth
                : "01",
            birthYear: this.companyRegistrationObj.inputValue === "not_registered"
                ? this.birthYear
                : "1990",
            //mapping
            citizenship: this.citizenship,
            companyRegistration: this.companyRegistrationObj.inputValue,
            company: this.companyNameObj.inputValue,
            title: this.titleObj.inputValue,
            firstName: this.firstNameObj.inputValue,
            lastName: this.lastNameObj.inputValue,
            companyRegistrationEntry: this.companyRegistrationEntryObj.inputValue,
            registrationNumber: this.registrationNumberObj.inputValue,
            companyLegalLocation: this.companyLegalLocationObj.inputValue,
            street: this.streetObj.inputValue,
            streetNumber: this.streetNumberObj.inputValue,
            zipCode: this.zipCodeObj.inputValue,
            city: this.cityObj.inputValue,
            phonePrefix: this.phonePrefixObj.inputValue,
            phoneNumber: this.phoneNumberObj.inputValue,
            email: this.emailObj.inputValue,
            password: this.passwordObj.inputValue,
            fixednetCustomerNumber: this.fixednetCustomerNumberObj.inputValue,
            divergentBillingAddress: this.divergentBillingAddressObj.inputValue,
            divergentBillingAddressName: this.divergentBillingAddressNameObj.inputValue,
            divergentBillingAddressStreet: this.divergentBillingAddressStreetObj.inputValue,
            divergentBillingAddressStreetNumber: this.divergentBillingAddressStreetNumberObj.inputValue,
            divergentBillingAddressZipCode: this.divergentBillingAddressZipCodeObj.inputValue,
            divergentBillingAddressCity: this.divergentBillingAddressCityObj.inputValue,
        };
        this.onContactDetailsSubmit(contactDetails);
    };
    ContactDetailsComponent.prototype.resetValidator = function () {
        this.citizenshipError = false;
        this.birthDateError = false;
    };
    ContactDetailsComponent.prototype.onChangeDate = function () {
        var month = parseInt(this.birthMonth, 10);
        var year = parseInt(this.birthYear, 10);
        if (!month) {
            month = 1;
        }
        if (!year) {
            year = new Date().getFullYear();
        }
        var numberOfDays = this.daysInMonth(month, year);
        if (numberOfDays < 25 || !numberOfDays) {
            numberOfDays = 31;
        }
        this.days = [];
        for (var i = 1; i < numberOfDays + 1; i++) {
            this.days.push(i.toString());
        }
    };
    ContactDetailsComponent.prototype.daysInMonth = function (month, year) {
        return new Date(year, month, 0).getDate();
    };
    return ContactDetailsComponent;
}());
export { ContactDetailsComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/contact-details/contact-details.component.ts
// module id = null
// module chunks = 